// DropBuyDataGrid.js
import React from 'react';
import { DataGridPro } from "@mui/x-data-grid-pro";
import { DropBuyUrlRedirect, DropBuyUrlRedirectCopyIcon,  } from './DropBuyUrlRedirect';

const columns = [
  { headerName: "Job ID", field: "jobID", flex: 0.2 },
  {
    headerName: "Event",
    field: "eventName",
    flex: 0.45,
    renderCell: (params) => <DropBuyUrlRedirect params={params}/>,
  },
  {
    headerName: "",
    field: "copyLink",
    width: 45,
    align: "center",
    renderCell: (params) => <DropBuyUrlRedirectCopyIcon params={params} />,
  },
  { headerName: "Venue", field: "venueName", flex: 0.45 },
  { headerName: "Date", field: "event_Date", flex: 0.3 },
  { headerName: "Notes", field: "dropBuyNote", flex: 1 },
].map((column) => ({ ...column, sortable: false }));

export const DropBuyDataGrid = React.memo(({ dropBuy }) => (
  <DataGridPro
    sx={{
      borderRadius: "1em",
      backgroundColor: "white",
      padding: "1em",
    }}
    columns={columns}
    getRowId={(row) => row._id}
    rows={dropBuy}
    disableColumnMenu
    disableSelectionOnClick
  />
));
